import { createFileRoute } from "@tanstack/react-router";

import AddAccount4 from "@/features/onboarding/AddAccount4";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-account-4")({
  component: () => (
    <BasicLayout>
      <AddAccount4 />
    </BasicLayout>
  ),
});
